<template>
	<PrePurchasedAssignCard :value="value" class="pa-0" flat readonly hide-title />
</template>

<script>
import PrePurchasedAssignCard from '@/components/PrePurchasedAssignCard';
import { PaginationModel } from '@connectngo/sdk';

export default {
	name: 'VirtualWalletPrePurchasedListing',

	components: { PrePurchasedAssignCard },

	props: {
		value: {
			type: PaginationModel,
			default: () => new PaginationModel(),
		},
	},
}
</script>
